<template>
  <component
    :is="pageLayoutComponent"
    title="Základní údaje"
    :next="true"
    @next="onNext"
    :prev="prevRoute"
  >
    <ReachDialBox :store-namespace="storeNamespace" />

    <component
      class="mt-4"
      :is="audienceTemplateComponent"
      :template="template"
      :store-namespace="storeNamespace"
    />

    <gender class="mt-4" v-model="genders" :genders="targetingGendersTypes" />
    <age :age-from="ageFrom" :age-to="ageTo" @input="onAgeInput" />
    <geo-locations :store-namespace="storeNamespace" />

    <!--    <v-row row wrap>-->
    <!--      <v-col lg="12">-->
    <!--        <v-btn-->
    <!--          @click="showAdvancedSettings = !showAdvancedSettings"-->
    <!--          text-->
    <!--          small-->
    <!--          class="ml-n2 clr-black-l"-->
    <!--        >-->
    <!--          Pokročilé nastavení-->
    <!--          <img-->
    <!--            class="ml-2"-->
    <!--            :src="require('@/assets/ico-chevron-down.svg')"-->
    <!--            :style="{-->
    <!--              transform: showAdvancedSettings ? 'rotate(-180deg)' : 'rotate(0)',-->
    <!--              transition: 'transform 200ms',-->
    <!--            }"-->
    <!--            alt=""-->
    <!--          />-->
    <!--        </v-btn>-->
    <!--      </v-col>-->
    <!--    </v-row>-->

    <!--
      Not implemented yet:
      <advanced-settings v-if="showAdvancedSettings" />
    -->

    <template #navigation-right>
      <v-btn
        color="white"
        class="c-btn mx-2"
        :to="targetingSummaryRoute"
        min-width="186"
      >
        Přeskočit na shrnutí
        <v-icon right>
          mdi-fast-forward-outline
        </v-icon>
      </v-btn>
    </template>
  </component>
</template>

<script>
import { get, sync } from "vuex-pathify"

// import PageLayout from "@/components/page/ads/edit/PageLayout.vue"
import Gender from "@/components/ui/targeting/Gender.vue"
import Age from "@/components/ui/targeting/Age.vue"
import GeoLocations from "@/components/ui/targeting/GeoLocations.vue"
import ReachDialBox from "@/components/ui/targeting/ReachDialBox.vue"
import validation from "@/mixins/validation"
// import AdvancedSettings from "@/components/page/home/newcampaign/audienceInfo/AdvancedSettings.vue"

export default {
  name: "TargetingBasics",
  components: {
    // PageLayout,
    ReachDialBox,
    Gender,
    Age,
    GeoLocations,
    // AdvancedSettings,
  },
  mixins: [validation],
  props: {
    id: {
      type: String,
      default: null,
    },
    nextRoute: {
      type: String,
      default: null,
    },
    prevRoute: {
      type: String,
      default: null,
    },
    targetingSummaryRoute: {
      type: String,
      default: null,
    },
    storeNamespace: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      audienceTemplateComponent: null,
      showAdvancedSettings: false,
    }
  },
  computed: {
    ...get("enumerations", ["targetingGendersTypes"]),
    ...sync("app", ["videoTutorial"]),
    pageLayoutComponent() {
      return () =>
        import(`@/components/page/${this.storeNamespace}/edit/PageLayout.vue`)
    },
  },
  methods: {
    getAudienceTemplateComponent() {
      const template = this.audienceSubType === "template" && this.template.id

      if (template) {
        return () =>
          import(`@/components/ui/audiences/templates/${template}.vue`)
      }

      return false
    },
    onAgeInput(val) {
      this.ageFrom = val[0]
      this.ageTo = val[1]
    },
    onNext() {
      if (this.isValidAll()) {
        this.$router.push(this.nextRoute)
      }
    },
  },
  beforeMount() {
    this.audienceTemplateComponent = this.getAudienceTemplateComponent()
  },
  beforeCreate() {
    const storeNamespace = this.$options.propsData.storeNamespace

    if (!this.$options.computed) {
      this.$options.computed = {}
    }

    Object.assign(this.$options.computed, {
      ...get(`${storeNamespace}/model@audience`, [
        "audienceSubType",
        "template",
      ]),
      // ...sync(`${storeNamespace}`, ["age"]),
      ...sync(`${storeNamespace}/model@audience.targeting`, [
        "ageFrom",
        "ageTo",
        "genders",
      ]),
    })
  },
  mounted() {
    this.videoTutorial = "https://player.vimeo.com/video/693576497?h=7ffc4b4339"
  },
}
</script>
